module.exports = __webpack_public_path__ + "static/szenario4_1-5ddaa11afc05e01fa22691b0b387a891.png";